import moment from 'moment';
import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import ButtonOutline from 'UiKit/button/buttonOutline';
import { TextSemiBold } from 'UiKit/typography';

import { useReportAttendanceState } from 'View/report-attendance/state';

import styles from './styles.module.css';

const ActionButton = ({ values, isOperator }) => {
  const navigate = useNavigate();
  const monthYear = isOperator ? moment(values?.reportPeriod, 'MMMM YYYY').format('MM-YYYY') : null;
  const { filterState } = useReportAttendanceState();

  const filterStateDate = `${moment(filterState?.startedAt).format('DDMMYYYY')}-${moment(filterState.endedAt).format('DDMMYYYY')}`;

  const href = isOperator
    ? `/report/operator-attendance/${values.operatorId}?monthYear=${monthYear}`
    : `/report/host-attendance/${values.hostId}?date=${filterStateDate}`;

  const handleNavigate = () => {
    navigate(href);
  };

  return (
    <Box className={styles['action-button__container']}>
      <ButtonOutline borderWidth="1.5px" className={styles['action-button__button-detail']} onClick={handleNavigate} data-testid="action-button__button-detail">
        <TextSemiBold className={styles['action-button__button--text']}>Detail</TextSemiBold>
      </ButtonOutline>
    </Box>
  );
};

export default ActionButton;
